let GetRewardsNormalPanel = xClass("GetRewardsNormalPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/getRewardNomalPanel.pack"
)
GetRewardsNormalPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
GetRewardsNormalPanel.preloadResPromise = function (useMask = false) {
    return preloadWithLoadingPromise(RES, useMask)
}
let _instance = null
GetRewardsNormalPanel.getInstance = function () {
    let self = this
    return _instance
}
/**
 * 
 * @param {*} data   
 *  data = {
        title:"",
        desc:"",
        add_model:false,//是否同步商品到本地信息（部分接口会自行同步 部分不会 默认这里为false）
        rewardList:[],
        closeCb:null
    }
    示例
        GetRewardsNormalPanel.show({
            title:"恭喜获得补星道具",
            desc:"仅限当天使用",
            add_model: "test",// test 为获取道具的category
            rewardList: [{
                "itemId": 10031,
                "num": 1
            }],
            closeCb:()=>{
                
            }
        })
 */
GetRewardsNormalPanel.show = function(data){
    var loadPanelSuccess = function(){
        GetRewardsNormalPanel.create(data);
    }
    preloadWithLoading(RES, loadPanelSuccess, function () {
        Toast.make(getText("error.tip.load_res_error"));
    }, function () {
        Toast.make(getText("error.tip.load_canceled"));
    });
}
GetRewardsNormalPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self
    self.ssManager = SeasideStarManager.getInstance();
    this.data = {
        title:"",
        titleAlignment:null,
        desc:"",
        add_model:false,//是否同步商品到本地信息（部分接口会自行同步 部分不会 默认这里为false）如果需要 记得传入打点的category
        rewardList:[],
        closeCb:null
    }
    if(data){
        for (const key in this.data) {
            if(data[key]) this.data[key] = data[key]
        }
    }

    self.initUI();
    self.popup(true);
}
GetRewardsNormalPanel.prototype.addCloseCb = function (callback) {
    let self = this
    self.data.closeCb = callback
}
GetRewardsNormalPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    this.data.closeCb && this.data.closeCb()
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
GetRewardsNormalPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}

GetRewardsNormalPanel.prototype.initUI = function () {
    // let rewards = [{
    //         "itemId": 10001,
    //         "num": 1
    //     },
    //     {
    //         "itemId": 10001,
    //         "num": 1
    //     },
    // ]
    let rewards = this.data.rewardList
    // for (let i = 0; i < 3; i++) {
    //     rewards.push({
    //         "itemId": 10003,
    //         "num": 1
    //     })

    // }
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/get_reward_nomal_panel_reward_video.csb")
    self.addChild(self.mainNode);
    self.mainNode.anim = cc.CSLoader.createTimeline("cocos/get_reward_nomal_panel_reward_video.csb");
    self.mainNode.runAction(self.mainNode.anim);
    self.mainNode.anim.gotoFrameAndPlay(0,36, false)
    self.mainNode.anim.setLastFrameCallFunc(() => {
        self.mainNode.anim.gotoFrameAndPlay(37, true)
    });
    for (let i = 1; i <= 4; i++) {
        let conf = self.mainNode.getChildByName("stargolow0002+"+i)
        conf.setBlendFunc(table([1, "src", gl.ONE], [1, "dst", gl.ONE]))
    }



    let lenght = rewards.length < 5 ? rewards.length : 5

    let itemWidth = 100
    let startX = -itemWidth / 2 * (lenght - 1)
    this.flyItemOps = table();
    for (let i = 0; i < lenght; i++) {
        let reward = rewards[i];
        let icon = UIItemBuilder.createProp(reward.itemId, reward.num)[0]
        this.addChild(icon)
        icon.x = startX + i * itemWidth

        let pos = icon.parent.convertToWorldSpace(cc.p(icon.getPosition()))
        var winSize = cc.Director.getInstance().getWinSize();
        pos.x = pos.x + winSize.width / 2;
        pos.y = pos.y + winSize.height / 2;

        table.insert(this.flyItemOps, {
            itemId: tonumber(reward.itemId),
            num: tonumber(reward.num),
            pos: pos,
            scale: 1
        })

        this.data.add_model && UserProp.getInstance().rewardProp(tonumber(reward.itemId), reward.num, null, null, this.data.add_model);
    }


    let textTip = cc.LabelTTF.create(this.data.desc , null, 25);
    let txt1 = self.mainNode.getChildByName("txt1")
    txt1.addChild(textTip)
    textTip.x = txt1.width/2


    let textTitle = cc.LabelTTF.create(this.data.title , null, 36);
    let toptitle_watchvideo = self.mainNode.getChildByName("toptitle_watchvideo")
    toptitle_watchvideo.addChild(textTitle)
    textTitle.x = toptitle_watchvideo.width/2
    textTitle.y = toptitle_watchvideo.height
    if (this.data.titleAlignment){
        textTitle.setAlignment(this.data.titleAlignment)
    }

}
/**
 * 点击空位置
 */
GetRewardsNormalPanel.prototype.onClickEmpty = function () {
    var self = this
    if (self.isBusy){
        return
    }
    self.isBusy = true
    HomeSceneAnimation.playGetPropAnimation(this.flyItemOps, () => {
        self.onClose()
    }, 0.1);
}




module.exports = GetRewardsNormalPanel